module.exports = __webpack_public_path__ + "assets/img/sy.9768098d.png";